import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { AvatarWrapper } from '@/components/ui/avatar';
import { IconWrapper, IconStars, IconVerified } from '@/components/custom/icon';
import { FiBell, FiCheck, FiHeart, FiSettings, FiStar, FiUser } from 'react-icons/fi';

export function IconsSection() {
  return (
    <ShowcaseSection
      id="icons"
      title="Icons & Avatars"
      description="Avatares, IconWrapper, IconStars, IconVerified"
    >
      <ShowcaseItem
        label="Avatar"
        description="6 tamanhos: xs (24px), sm (32px), default (40px), md (64px), lg (128px), xl (160px)"
      >
        <div className="flex flex-wrap items-end gap-4">
          {[
            { size: 'xs', name: 'Ana' },
            { size: 'sm', name: 'Bruno' },
            { size: 'default', name: 'Carlos' },
            { size: 'md', name: 'Diana' },
            { size: 'lg', name: 'Eduardo' },
            { size: 'xl', name: 'Fabio' }
          ].map(a => (
            <div
              key={a.size}
              className="flex flex-col items-center gap-1"
            >
              <AvatarWrapper
                name={a.name}
                size={a.size}
              />
              <code className="text-[10px] text-neutral-500">{a.size}</code>
            </div>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="AvatarWrapper com imagem"
        description="Renderiza imagem; faz fallback para iniciais se faltar"
      >
        <div className="flex items-center gap-4">
          <AvatarWrapper
            name="Joao Silva"
            image={{ url: 'https://i.pravatar.cc/150?img=10' }}
            size="md"
          />
          <AvatarWrapper
            name="Maria Souza"
            size="md"
          />
          <AvatarWrapper
            name="Pedro Costa"
            image={{ url: 'https://i.pravatar.cc/150?img=12' }}
            size="md"
          />
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="IconWrapper — Tamanhos"
        description="xs, sm, default, md, lg"
      >
        <div className="flex flex-wrap items-end gap-3">
          {['xs', 'sm', 'default', 'md', 'lg'].map(size => (
            <div
              key={size}
              className="flex flex-col items-center gap-1"
            >
              <IconWrapper size={size}>
                <FiUser />
              </IconWrapper>
              <code className="text-[10px] text-neutral-500">{size}</code>
            </div>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="IconWrapper — Cores"
        description="primary (default), secondary"
      >
        <div className="flex flex-wrap items-end gap-3">
          <div className="flex flex-col items-center gap-1">
            <IconWrapper color="primary">
              <FiHeart />
            </IconWrapper>
            <code className="text-[10px] text-neutral-500">primary</code>
          </div>
          <div className="flex flex-col items-center gap-1">
            <IconWrapper color="secondary">
              <FiBell />
            </IconWrapper>
            <code className="text-[10px] text-neutral-500">secondary</code>
          </div>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="IconWrapper — Variedades de icones"
        description="Demo com diferentes icones do react-icons"
      >
        <div className="flex flex-wrap items-center gap-3">
          {[FiUser, FiHeart, FiStar, FiBell, FiCheck, FiSettings].map((Icon, idx) => (
            <IconWrapper
              key={idx}
              size="md"
            >
              <Icon />
            </IconWrapper>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="IconStars"
        description="Icone customizado de estrelas"
      >
        <div className="flex items-center gap-4">
          <IconStars />
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="IconVerified"
        description="Icone de verificacao com tooltip"
      >
        <div className="flex items-center gap-4">
          <span className="text-sm text-primary-dark">Conta verificada</span>
          <IconVerified />
        </div>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
